var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMark = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 8,
  viewBox: "0 0 10 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.75423 1.65542L4.42423 7.65975C4.23423 7.86991 3.96423 8 3.67423 8C3.38423 8 3.11423 7.87991 2.92423 7.65975L0.254229 4.65759C-0.115772 4.24729 -0.0757715 3.61684 0.334229 3.24657C0.744228 2.8763 1.37423 2.91633 1.74423 3.32663L3.66423 5.48819L8.25423 0.33447C8.62423 -0.0758262 9.25423 -0.115855 9.66423 0.254412C10.0742 0.624679 10.1142 1.25513 9.74423 1.66543L9.75423 1.65542Z",
  fill: "#FDA700"
})));
export { SvgMark as ReactComponent };
export default __webpack_public_path__ + "assets/icons/mark.ff6122.svg";